import React, { useState } from "react";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import DefaultButton from "../../styles/materialButtonStyle";
import { TextField } from "@material-ui/core";
import Notification from "../notification/Notification";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import axios from "axios";

import MaterialDialog from "../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";

const CancelBatches = ({ t, fetchBatches, batches, notification, setNotification }) => {
  const [open, setOpen] = useState(false);

  const defaultData = {
    "twofa": null
  };

  const [requestData, setRequestData] = useState(defaultData);
  const [disabled, setDisabled] = useState(false);

  const cancelBatch = async (event) => {
    event.preventDefault();
    setDisabled(true);

    axios.put("/api/cancel-batches/" + batches.id, requestData, userAuthenticationConfig(false)).
      then(response => {
        if (response.status === HTTP_STATUSES.HTTP_OK) {
          setNotification({ ...notification, visible: true, type: "success", message: t("cancel.success") });
          fetchBatches();
          handleClose();
        }
      }).
      catch(error => {
        parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
      }).finally(() => {
      setDisabled(false);
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setRequestData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <React.Fragment>
        <DefaultButton
          className="stop-event"
          color="transparent"
          border="danger"
          onClick={handleClickOpen}
        >
          {t("table.cancel")}
        </DefaultButton>
        <MaterialDialog
          className="stop-event"
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("cancel.title")} {batches.name}
            </StyledDialogHead>
            <StyledDialogContent>
              <p>{t("cancel.text")}</p>
              <TextField
                id="twofa"
                label={t("table.twofa")}
                value={requestData.twofa}
                onChange={(data) => setRequestData({ ...requestData, twofa: data.target.value })}

              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("table.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={cancelBatch}
                color="success"
                disabled={disabled}
              >
                {t("cancel.confirm")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </React.Fragment>
    </>
  );
};

export default CancelBatches;